import React, { useEffect, useState } from 'react';

import AbstractWindow from './AbstractWindow';

import 'react-phone-number-input/style.css';

import PhoneInput from 'react-phone-number-input';

import { createBuildSheet, sendBuildSheet } from '../../api/cars';

import { useHistory, useLocation } from 'react-router-dom';

import { downloadFile } from '../../helpers/utils';

import FileArrowDownIcon from '../icons/FileArrowDownIcon';

const SendBuildWindow = () => {

    const [ phone, setPhone ] = useState( '' );

    const [ firstName, setFirstName ] = useState( '' );

    const [ lastName, setLastName ] = useState( '' );

    const [ email, setEmail ] = useState( '' );

    const [ sending, setSending ] = useState( false );

    const [ error, setError ] = useState();

    let location = useLocation();

    let history = useHistory();

    useEffect( () => {
        
        console.log("BUILD SEND WINDOW");

        console.log( location.state );
    }, [] )

    useEffect( () => {

        if( firstName && lastName && phone && email && firstName != "" && lastName != "" && phone != "" && email != "" ){

            setError( null );

        } else {
            setError( "All fields are required.");
        }
    }, [ firstName, lastName, email, phone ] )

    const onSubmit = e => {

        e.preventDefault();

        if( !firstName || !lastName || !phone || !email ){

            setError( "All fields are required.");

            return;
        }

        const data = { options: location.state.currentConfiguration };

        Object.keys( data.options ).forEach( k => {

            let v = data.options[ k ];

            if( Array.isArray( v ) ){

                if( v.length > 0 ){

                    let labels = v.map( a => a.label )

                    data.options[ k ] = {
                        group_label: v[0].group_label,
                        test: v[0],
                        label: labels.join(', ')
                    }
                } else {
                    delete data.options[ k ];
                }
            }
        } );

        if( window.api ) window.api.getScreenShot( 1080, 768, 'image/jpeg', ( error, image ) => {

            data.car = location.state.car;

            data.image = image;

            setSending( true );

            createBuildSheet( data ).then( build_sheet_data => {

                let form_data = { phone, firstName, lastName, email, file: build_sheet_data.pdf, send_to: location.state.send_to };

                console.log( form_data );

                sendBuildSheet( form_data ).then( send_data => {
                                        
                    console.log( "send build sheet result: ", JSON.parse( send_data ) );

                    downloadFile( build_sheet_data.pdf, 'buildsheet' + Date.now() + '.pdf' );

                    setSending( false );

                    history.goBack();
                } ).catch( error => {

                    console.log( error );

                    setError( "There was a problem sending the email.");
    
                    setSending( false );
                } );
            } ).catch( error => {

                console.log( error );

                setError( "There was a problem creating the build sheet.");

                setSending( false );
            } );
        } );
    }

    return <AbstractWindow id={ 'send-build' } className="d-flex align-items-center justify-content-center" style={{backgroundColor:"#eeeeee66"}}>
        <div className="bg-white d-flex p-2 rounded-4 align-items-start" style={ { width: 500 } }>
            { location.state.currentConfiguration && <div className="flex-grow-1 d-flex flex-wrap pos-rel" style={ { gap: 10 } }>
                <form onSubmit={ onSubmit }>
                    <div className='d-flex flex-column pos-rel' style={{gap:30}}>
                        <h4 className="medium text-center">{ location.state.window_title }</h4>
                        <div className="d-flex flex-wrap" style={{gap:10}}>
                            <div className="d-flex flex-column" style={ { flex: "1 1 calc( 50% - 5px )", gap:8 } } >
                                <label>First Name</label>
                                <input value={ firstName } type="text" placeholder='First name' required onChange={ e => setFirstName( e.target.value ) } />
                            </div>
                            <div className="d-flex flex-column" style={ { flex: "1 1 calc( 50% - 5px )", gap:8 } } >
                                <label>Last Name</label>
                                <input value={ lastName } type="text" placeholder='Last name' required onChange={ e => setLastName( e.target.value ) } />
                            </div>
                            <div className="d-flex flex-column" style={ { flex: "1 1 100%", gap:8 } } >
                                <label>{"Phone (please select country or include country code)"}</label>
                                <PhoneInput required={true} placeholder="Enter phone number" value={ phone } onChange={ setPhone }/>
                            </div>
                            <div className="d-flex flex-column" style={ { flex: "1 1 100%", gap:8 } } >
                                <label>Email</label>
                                <input value={ email } type="email" placeholder='Email' required onChange={ e => setEmail( e.target.value ) } />
                            </div>
                        </div>
                        <div><p className="small">{error}</p></div>
                        <div className='d-flex' style={ { gap: 10 } }>
                            <button disabled={ sending || error } className="btn btn-black d-flex align-items-center" style={ { gap: 10 } }>
                                <span className='h5 m-0'><FileArrowDownIcon /></span><span className='hide-m small m-0'>SEND AND DOWNLOAD</span>
                            </button>              
                            <button type="button" onClick={ e =>{ e.stopPropagation(); history.goBack() }} className="ml-auto btn btn-black">
                                <span>CANCEL</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div> }
        </div>
    </AbstractWindow>
}

SendBuildWindow.propTypes = {
}

export default SendBuildWindow;